// prod
// export const base_url: string =
//   "https://reprise-vendeur-api.azurewebsites.net/";
// dev
/* export const base_url: string =
  "https://reprise-vendeur-api-dev.azurewebsites.net/"; */
// iso
export const base_url: string =
  "https://reprise-vendeur-api-iso.azurewebsites.net/";
// "https://reprise-vendeur-api-dev.azurewebsites.net/";
